<template>
    <div class="mvt-mortgage grid xs-grid-cols-1">
        <template v-if="showRefinance">
            <div class="calculator grid xs-grid-cols-1" v-ga:impression="'mortgage-rates'">
                <div class="group-info">
                    <div :class="showCheckScore?'text-small':'text-bold'">For accurate rates, estimate credit score. <a v-if="showCheckScore" class="link text-small" @click="openCreditScoreLink">(check score)</a></div>
                    <mvtSelect :data="creditList"  v-model="credit" />
                </div>
                <div class="inline small corner bg-default outline shown">
                    <a class="flex middle" data-id="mortgage" @click="toogleResult"><span>{{molang('dpp.propertyMortgage.mortgageRates')}}</span></a>
                    <mvtLazyload v-if="!cordlessLoaded" ref="lazyload" :async="true" data-role="mortgageratecard">
                        <div class="mortgage-result grid xs-grid-cols-1"  :class="{less: !showAll}">
                            <span class="f8">{{mortgageRateSubHeader}}</span>
                              <template v-if="sortedMortgageResult && sortedMortgageResult.length">
                                <mvtCardMortgage v-for="item in sortedMortgageResult" :data="item" :provider="providerNameForMR" :key="item.cpc + item.NMLS" :state="state" />
                                <a v-if="sortedMortgageResult.length > 3" @click="toogleLink" class="show-hide-toggle" :class="{'shown':showAll}" role="button">{{showAll ? 'Show Fewer Mortgage Details' : 'Show All Mortgage Details'}} <i></i></a>
                                <div class="f8" v-if="!isBankRate && disclaimerHtml" v-html="disclaimerHtml"></div>
                                <div v-else-if="isBankRate">
                                    <bankrateFooter/>
                                </div>
                            </template>
                            <div v-else-if="mortgageRatesLoaded" class="mortgage-noresult">
                                <div>
                                    <b>{{molang('dpp.propertyMortgage.noMatch')}}</b>
                                </div>
                                <a @click="show3rdPartyForm('findlowrate', 'refinance', molang('dpp.propertyMortgage.findLowRate'), false, $event)" class="link f7">
                                    {{molang('dpp.propertyMortgage.connectLocalLender')}}
                                    <br>
                                    {{molang('dpp.propertyMortgage.findLowRate')}}
                                </a>
                            </div>
                        </div>
                    </mvtLazyload>
                    <div id="cmrtwidget"></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div id="topLink" v-if="topVeteran && topVeteran.id && cpc3wayPayment"><a class="link" @click="show3rdPartyForm(topVeteran.id, 'veteransUnited2', topVeteran.cta, false, $event)" rel="nofollow noreferrer" role="button">{{topVeteran.cta}}</a> <i class="icon-external-link"></i></div>
            <div class="flex middle lh-normal">
                <div>
                    <span class="f4 text-bold">{{$filters.formatPrice(pricePerMonth)}}</span> <span class="f7">/ month</span>
                </div>
                <a v-if="!hideLenderButton && cpc3wayPayment" class="btn primary small" @click="showForm(principalInterestObj)" role="button">
                    {{principalInterestObj.cta}}
                </a>
            </div>
            <div class="process-bar">
                <div v-for="item in chartData" :style="{ width: item.value}" :type="item.key" :key="item.key"></div>
            </div>
            <div class="calculator grid xs-grid-cols-1" v-ga:impression="'mortgage-rates'">
                <div class="inline small corner bg-default outline">
                    <a class="flex middle left" data-role="toggle" data-id="PI" role="button">
                        <i class="dot" type="Interest"></i>
                        <div>{{molang('dpp.propertyMortgage.principalInterest')}}</div>
                        <div class="m-l-auto"><span class="text-bold" v-if="loanPerMonth>=0">{{!loanPerMonth ? `$0` : $filters.formatPrice(loanPerMonth)}}</span> <i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <div class="group merge">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="downpayment">{{molang('dpp.propertyMortgage.downPaymentCash')}}</label>
                                    <mvtInputNumber id="downpayment" v-model="downpayment" @input="$event=>updateDownPayment(true)" :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                            <mvtTextbox>
                                <div class="input">
                                    <label for="downpaymentRate">{{molang('dpp.propertyMortgage.percent')}}</label>
                                    <mvtInputDecimalNumber id="downpaymentRate" v-model="downpaymentRate" @input="$event=>updateDownPayment(false)" :suffix="'%'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                        <div class="group">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="downpaymentEquity">{{molang('dpp.propertyMortgage.downPaymentEquity')}}</label>
                                    <mvtInputNumber id="downpaymentEquity" v-model="downpaymentEquity" @input="updateDownPayment(true)" :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                        <div class="group merge">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="homePrice">{{molang('dpp.propertyMortgage.homePrice')}}</label>
                                    <mvtInputNumber id="homePrice" v-model="homePrice" @input="algothrim" :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                            <mvtTextbox>
                                <div class="input">
                                    <label for="interestRate">{{molang('dpp.propertyMortgage.interestRate')}}</label>
                                    <mvtInputDecimalNumber id="interestRate" v-model="interestRate" @input="algothrim" :suffix="'%'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                        <div class="group-info">
                            <div class="text-bold">Loan type</div>
                            <mvtSelect :data="interestRateList" v-model="interestRateIndex" placeholder="Loan Type" @change="updateInterstRate" />
                        </div>
                        <div class="group-info">
                            <div class="text-bold">Estimated credit score</div>
                            <mvtSelect :data="creditList"  v-model="credit" />
                        </div>
                        <div class="group-footer">
                            <a class="link f7" v-if="!creditTextButton" @click="show3rdPartyForm('compareMortRates', 'refinance', molang('dpp.propertyMortgage.compareTodaysMortgageRates'), false, $event)" role="button">{{molang('dpp.propertyMortgage.compareTodaysMortgageRates')}}</a>
                        </div>
                    </div>
                </div>
                <div class="inline small corner bg-default outline">
                    <a class="flex middle left" data-role="toggle" data-id="propertyTax" role="button">
                        <i class="dot" type="Taxes"></i>
                        <div>Taxes</div>
                        <div class="m-l-auto"><span  class="text-bold" v-if="taxPerMonth">{{$filters.formatPrice(taxPerMonth)}}</span> <i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <div class="group merge">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="propertyTax">{{molang('dpp.propertyMortgage.taxEstimate')}}</label>
                                    <mvtInputNumber id="propertyTax" v-model="propertyTax" @input="$event=>updateTaxRate(true)"  :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                            <mvtTextbox>
                                <div class="input">
                                    <label for="propertyTaxRate">{{molang('dpp.propertyMortgage.percent')}}</label>
                                    <mvtInputDecimalNumber id="propertyTaxRate" v-model="propertyTaxRate" @input="$event=>updateTaxRate(false)" :suffix="'%'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                    </div>
                </div>
                <div class="inline small corner bg-default outline">
                    <a class="flex middle left" data-role="toggle" data-id="homeInsurance" role="button">
                        <i class="dot" type="Insurance"></i>
                        <div>Insurance </div>
                        <span id="getquotes" class="btn secondary small" @click="show3rdPartyForm('getquotes', 'insurance1', '', false, $event)" target="_blank">{{molang('dpp.getQuotes')}}</span>
                        <div class="m-l-auto"><span  class="text-bold" v-if="homeInsurancePerMonth">{{$filters.formatPrice(homeInsurancePerMonth)}}</span><i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <div class="group">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="homeInsurance">{{molang('dpp.propertyMortgage.homeInsurance')}}</label>
                                    <mvtInputNumber id="homeInsurance" v-model="homeInsurance" @input="algothrim" :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                        <div class="group-footer"><a class="link f7" @click="openInsProvider" role="button">Find an insurance provider today</a> <i class="icon-external-link"></i></div>
                    </div>
                </div>

                <div class="inline small corner bg-default outline" v-show="pmiPerMonth">
                    <a class="flex middle left" data-role="toggle" data-id="mortgageInsurance" role="button">
                        <i class="dot" type="PMI"></i>
                        <div>Mortgage Insurance</div>
                        <div class="m-l-auto"><span class="text-bold">{{$filters.formatPrice(pmiPerMonth)}}</span><i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <div class="group-info f7">
                            Mortgage insurance protects the lender and is usually required for down payments below 20%
                        </div>
                        <div class="group-footer"><a class="link f7" href="https://www.freescoreonline.com/welcome/4p/d/landing-qh398h4f.html?id=3782&ord=1&append=1&edata=2&edata2=&edata5=&rid=178716825&siteId=230&transid=178716825&cakeEventId=4&EDATA6=178716825" ref="nofollow">Check Your Credit</a> <i class="icon-external-link"></i></div>
                    </div>
                </div>
                <div class="inline small corner bg-default outline" v-show="propertyHoafee">
                    <a class="flex middle left" data-role="toggle" data-id="monthlyHOA" role="button">
                        <i class="dot" type="HOA"></i>
                        <div>Monthly HOA fee</div>
                        <div class="m-l-auto"><span class="text-bold" v-if="hoaPerMonth">{{$filters.formatPrice(hoaPerMonth)}}</span><i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <div class="group">
                            <mvtTextbox>
                                <div class="input">
                                    <label for="propertyHoafee">{{molang('dpp.propertyMortgage.monthlyHoa')}}</label>
                                    <mvtInputNumber id="propertyHoafee" v-model="propertyHoafee" @input="algothrim" :prefix="'$'"/>
                                </div>
                            </mvtTextbox>
                        </div>
                        <div class="group-footer"><a id="homebuyers" target="_blank" class="link f7" rel="nofollow noreferrer" @click="show3rdPartyForm('homebuyers_checkYourCredit', 'credit', '', false, $event)" role="button">{{molang('dpp.propertyMortgage.checkCreditNow')}}</a> <i class="icon-external-link"></i></div>
                    </div>
                </div>
                <div id="paymentInternetAndCable" class="inline small corner bg-default outline" :class="{shown:openIACProvider}" v-if="internetCableMonthly">
                    <a class="flex middle left" @click="toogleIACProvider" role="button">
                        <i class="dot" type="IAC"></i>
                        <div>Internet & Cable</div>
                        <div class="m-l-auto"><span class="text-bold">${{internetCableMonthly}}</span><i class="icon-angle-down"></i></div>
                    </a>
                    <div class="grid xs-grid-cols-1">
                        <internetcableProvider :zipcode="zipcode" :state="state" :city="city"/>
                    </div>
                </div>
                <div class="paragraph f7"  v-if="showDataSource">
                    {{molang('dpp.movotoPowered')}}
                </div>
                <div class="inline small corner bg-default outline" id="mortgageRatesResult" :class="{shown:openMorgage}">
                    <a class="flex middle" data-id="mortgage" @click="toogleResult"  role="button"><span>{{molang('dpp.propertyMortgage.mortgageRates')}}</span><i class="icon-angle-down"></i></a>
                    <div v-if="openMorgage" class="mortgage-result grid xs-grid-cols-1" :class="{less: !showAll}">
                        <span class="f8" v-if="!cordlessLoaded">{{mortgageRateSubHeader}}</span>
                        <template v-if="sortedMortgageResult && sortedMortgageResult.length">
                            <mvtCardMortgage v-for="item in sortedMortgageResult" :data="item" :openMortgage="openMorgage" :provider="providerNameForMR" :key="item.cpc + item.NMLS" :state="state" />
                            <a  v-if="sortedMortgageResult.length > 3" @click="toogleLink" class="show-hide-toggle" :class="{'shown':showAll}" role="button">{{showAll ? 'Show fewer mortgage rates' : 'Show all mortgage rates'}} <i></i></a>
                            <div v-if="informaDisclosureContent" class="m-b-2 advertiserDisclosure">
                                <a class="f7 link" href="javascript:;" rel="nofollow" role="button" v-tip :tip="informaDisclosureContent">Advertiser Disclosure</a>
                            </div>
                            <div v-if="isBankRate">
                                 <bankrateFooter/>
                            </div>
                             <div class="data-provider" v-else-if="informaDisclaimer && !cordlessLoaded" v-html="informaDisclaimer"></div>
                        </template>
                         <div v-else-if="mortgageRatesLoaded && !cordlessLoaded" class="mortgage-noresult">
                            <div>
                                <b>{{molang('dpp.propertyMortgage.noMatch')}}</b>
                            </div>
                            <a @click="show3rdPartyForm('findlowrate', 'refinance', molang('dpp.propertyMortgage.findLowRate'), false, $event)" class="link f7" role="button">
                                {{molang('dpp.propertyMortgage.connectLocalLender')}}
                                <br>
                                {{molang('dpp.propertyMortgage.findLowRate')}}
                            </a>
                        </div>
                    </div>
                    <div id="dppMortgageSection" ref="dppMortgageSection"></div>
                </div>
                <mvtLazyload id="additionalServices" v-if="showAdditionalServices && cpc3wayPayment">
                    <additionalServices :zipcode="zipcode" :state="state" :city="city" :price="price"  :propertyType="propertyType" :yearBuilt="yearBuilt" />
                </mvtLazyload>
            </div>
            <div id="bottomLinks" v-if="cpc3wayPayment">
                <div class="singleline">
                    <a id="checkYourCredit" target="_blank" class="link" @click="show3rdPartyForm('checkYourCredit', 'credit', '', false, $event)"
                    rel="nofollow noreferrer" role="button">{{molang('dpp.propertyMortgage.checkCredit')}}</a> <i class="icon-external-link"></i>
                </div>
                <div v-if="!hideApprovalButton && !isActive"  class="singleline"><a role="button" @click="showForm({utmcta:'lowerpayment', url:'refinance', cta:molang('dpp.propertyMortgage.lowerMortgagePayment')})" class="link">{{molang('dpp.propertyMortgage.lowerMortgagePayment')}}</a></div>
                <div v-show="bottomVeteran && bottomVeteran.id"><a class="link" role="button" @click="show3rdPartyForm(bottomVeteran && bottomVeteran.id, 'veteransUnited', bottomVeteran && bottomVeteran.cta, false, $event)">{{bottomVeteran ? bottomVeteran.cta : ''}}</a> <i class="icon-external-link"></i></div>
            </div>
        </template>
    </div>
</template>
<script src="./mvt-mortgage.js"></script>

<style lang="scss">
@use "./mvt-mortgage.scss" as *;
</style>
